export const InlineEdit = {
  Grid_Edit_Cell: _TL_('Edit cell of column {{columnName}} and row {{rowIndex}}'),
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  KoSchema_String_RemainingCharactersText: _TL_('{{count}} characters remaining'),
  KoSchema_String_ExceededCharactersText: _TL_('Exceeded by {{count}} characters'),
  SimpleForm_Button_Save: _TL_('Save'),
  SimpleForm_Button_Cancel: _TL_('Cancel'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_Number_Require_Numeric: _TL_('Field requires numeric value'),
  Validation_Number_Max_Length: _TL_('Number should not exceed max length'),
  Validation_Number_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_Number_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  conversionAdjustment_Options: _TL_('conversion adjustment options'),
  conversionAdjustment_Multiplier: _TL_('conversion rate adjustment'),
};
